import { Login, type LoginResult } from '@myosh/myosh-login';
import ReactGA from 'react-ga4';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { v4 } from 'uuid';
import Meta from '../features/meta/meta';

export default function LoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const sendSchemaLoginEvent = (schemaName: string) => {
    ReactGA.event({
      category: 'User',
      action: 'schema_login',
      label: schemaName,
    });
  };

  const onLoginSuccess = (result: LoginResult) => {
    sendSchemaLoginEvent(result.selectedSchema);

    const existingSessionId = localStorage.getItem(`sessionId-${result.selectedSchema}`);
    if (!existingSessionId) {
      // store a sessionId for the current schema
      localStorage.setItem(`sessionId-${result.selectedSchema}`, v4());
    }

    const redirectPath = localStorage.getItem('postLogInRedirect');
    if (redirectPath) {
      localStorage.removeItem('postLogInRedirect');
      return navigate(redirectPath, { replace: true });
    } else {
      return navigate('/', { replace: true });
    }
  };

  return (
    <>
      <Meta title={t('myosh-login')} />
      <Login onLoginSuccess={onLoginSuccess} />
    </>
  );
}
